import React from "react";
import cn from "classnames";
import { useLocation } from "react-router-dom";
import { Icon } from "@components/atoms/icon/icon";
import styles from "./users-icon-button.module.scss";
import { ToolTip } from "../tooltip/tooltip";
import { useUsersIconButtonHook } from "./use-users-icon-button-hook";

interface UsersIconButtonPropTypes {
  content: string;
  ariaLabel: string;
  iconName?: string;
  height?: number;
  width?: number;
  useHook?: () => { handleClick: () => void };
}

const DEFAULT_ICON_NAME = "users";
const DEFAULT_HEIGHT = 24;
const DEFAULT_WIDTH = 24;

const cssClassName = "users-icon-button";

export const UsersIconButton = ({
  content,
  ariaLabel,
  iconName = DEFAULT_ICON_NAME,
  height = DEFAULT_HEIGHT,
  width = DEFAULT_WIDTH,
  useHook = useUsersIconButtonHook,
}: UsersIconButtonPropTypes) => {
  const { handleClick } = useHook();
  const location = useLocation();

  const isActive = location.pathname === "/user-management";

  return (
    <ToolTip position={"bottom"} content={content}>
      <button
        type="button"
        className={cn(
          styles[cssClassName],
          styles[`${cssClassName}__hover`],
          styles[`${cssClassName}__center-content`],
          isActive && styles[`${cssClassName}__active`],
        )}
        onClick={handleClick}
        aria-label={ariaLabel}
      >
        <Icon name={iconName} width={width} height={height} />
      </button>
    </ToolTip>
  );
};
